import ProgramInfo from './ProgramInfo';

export default ProgramInfo;
